'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var asterisk = require('./asterisk-436ee6b3.js');
var fieldHint = require('./field-hint-cc714695.js');
var kebabCase = require('./kebabCase-b150ced7.js');
var index$5 = require('./index-131f8d23.js');
var component_styles = require('./component.styles-89fe8ebe.js');

var HqoPicker = function (_a) {
    var isActive = _a.isActive, onClick = _a.onClick, value = _a.value, placeholder = _a.placeholder, label = _a.label, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, fieldIcon = _a.fieldIcon, required = _a.required, error = _a.error;
    return (React__default.createElement(component_styles.HqoPickerWrapper, { "data-testid": "hqo-picker", className: className },
        React__default.createElement(component_styles.StyledLabel, { "data-testid": "hqo-picker-label", className: "picker-label" },
            label,
            required && React__default.createElement(asterisk.Asterisk, { "data-testid": "hqo-picker-asterisk" })),
        React__default.createElement(component_styles.PickerField, { onClick: !disabled ? onClick : undefined, isError: !!error, isActive: isActive, disabled: disabled, "data-testid": "hqo-picker-field", "data-cy": kebabCase.kebabCase_1(label) + "-picker-field", className: "picker-field" },
            fieldIcon,
            React__default.createElement(component_styles.Value, { "data-testid": "hqo-picker-value", className: "picker-value", disabled: disabled, value: value }, value !== null && value !== void 0 ? value : placeholder),
            React__default.createElement(component_styles.StyledDropDownIcon, { "data-testid": "hqo-picker-drop-down", icon: index$5.faSortDown }),
            error && React__default.createElement(component_styles.StyledExclamationMark, { "data-testid": "exclamation-mark", variant: "pink" })),
        error && React__default.createElement(fieldHint.FieldHint, { dataTestId: "hqo-picker-error", variant: "error" }, error)));
};

exports.HqoPicker = HqoPicker;
